<template>
  <v-row>
    <v-col cols="12" md="12" lg="12">
      <v-img height="95%" width="95%" style="margin:3%;" :src="imageUrl" v-on:error="ImgError"></v-img>
    </v-col>
    <v-col cols="12" md="12" lg="12">
      <v-btn
        style="width:95%;"
        class="ma-2"
        outlined
        @click="upload()"
      >{{ $tc('dashboard.menu.raceDetails.change_your_image') }}</v-btn>
      <input
        style="display:none;"
        type="file"
        id="uploadImage_"
        name="uploadImage_"
        accept="image/*"
        @change="onImageChange($event)"
        multiple
      />
    </v-col>
  </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import AsyncComputed from "vue-async-computed";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  data() {
    return {
      eventName: null,
      eventName_: null,
      raceName: null,
      startDay: null,
      startTime: null,
      raceLength: null,
      status: null,
      dro: null,
      dro_: null,
      imageUrl: null,
      eventId: null,
      raceDetails: [],
      isPromoter: null,
      failed_image: true
    };
  },
  asyncComputed: {
    imageUrl: async function() {
      var response = await this.api(
        "get",
        "/api/v1/promoter/race/getDisplayFlag/" +
          this.$route.params.id
      );

      this.dro_ = response.message.displayFlag == 1 ? 1 : 0;

      return response.message.displayFlag == 1
        ? this.$t("dashboard.menu.raceDetails.yes")
        : this.$t("dashboard.menu.raceDetails.no");
    }
  },
  methods: {
    upload() {
      document.getElementById("uploadImage_").click();
    },
    async onImageChange(e) {
      this.uploadImage_ = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.fileName = files[0].name;
      this.uploadImage();
    },
    async createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    async uploadImage() {
      const data = new FormData();
      data.append("image", this.uploadImage_);
      data.append("fileName", this.fileName);

      /*let axiosConfig = {
        headers: { "content-type": "multipart/form-data" }
      };*/

      // const response = await axios
      //   .post(
      //     `${this.root}/laravel/public/api/v1/users/current/promoter/race/updateRaceImage/${this.$route.params.id}`,
      //     data,
      //     axiosConfig
      //   )
      //   .catch(
      //     function(error) {
      //       const status = error.response.status;

      //       switch (status) {
      //         case 401:
      //           window.location.href = `${this.root}/login?message=You20are%20logged%20out!`;
      //           break;
      //       }
      //     }.bind(this)
      //   );

      // if (response.data.success == 1) {
      //   this.imageUrl =
      //     process.env.VUE_APP_ROOT + "/laravel/public/" + response.data.message;
      // }
    },
    async sendMessage(input) {
      this.menu_[input] = false;
    },
    async ImgError() {
      this.failed_image = false;
      this.imageUrl = "https://placehold.it/600x90?text=600 x 90 Ad";
    }
  }
};
</script>
